const showLoginErrorMessage = () => {
  setTimeout(() => {
    const errorElement = document.getElementById('signInError');
    errorElement?.classList?.add('visible');
  });
};

export default showLoginErrorMessage;
